import { ReactElement } from 'react'

import { IconColor } from './index'

import styles from './Icons.module.scss'

export const CircleSuccessIcon = (props: {
  size?: number
  color?: IconColor
}): ReactElement<any> => {
  const size = props.size || 24
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM17.2071 8.79289C17.5976 9.18342 17.5976 9.81658 17.2071 10.2071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071L7.79289 13.2071C7.40237 12.8166 7.40237 12.1834 7.79289 11.7929C8.18342 11.4024 8.81658 11.4024 9.20711 11.7929L11 13.5858L15.7929 8.79289C16.1834 8.40237 16.8166 8.40237 17.2071 8.79289Z'
        fill={props.color ? styles[props.color] : styles.textSuccessHighEm}
      />
    </svg>
  )
}
